const Resources = {

    table_headers: [
        {
            text:   'S. Scenario',
            align:  'start',
            value:  'staffing_scenario'
        },
        { 
            text:   'Description',
            value:  'description'
        },
        {
            text:   'Order',
            value:  'order'
        },
        {
            text:   'Frequency/Week',
            value:  'frequency_week'
        },
        {
            text:   'Daily Minutes',
            value:  'daily_minutes'
        },
        {
            text:   'Annual Minutes',
            value:  'annual_minutes'
        }

    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Budgeting',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Staffing Fixed',
            href:   '#',
            arrow:  "",
        },
    ],

}

export default Resources;